<script setup lang="ts">
/**
 * Segmented System / Light / Dark control. Persists via useTheme (localStorage)
 * and applies immediately. "System" follows the OS preference.
 */
import { useTheme, type ThemeMode } from '@/composables/useTheme'

const { mode, setMode } = useTheme()

const options: { value: ThemeMode; label: string; icon: string }[] = [
  { value: 'auto', label: 'System', icon: '🖥️' },
  { value: 'light', label: 'Light', icon: '☀️' },
  { value: 'dark', label: 'Dark', icon: '🌙' },
]
</script>

<template>
  <div
    class="inline-flex rounded-lg border border-border bg-muted p-0.5 text-sm"
    role="radiogroup"
    aria-label="Colour theme"
    data-testid="theme-toggle"
  >
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      role="radio"
      :aria-checked="mode === opt.value"
      :data-testid="`theme-${opt.value}`"
      class="rounded-md px-2 py-1 font-medium transition-colors"
      :class="
        mode === opt.value
          ? 'bg-card text-foreground shadow-xs'
          : 'text-muted-foreground hover:text-foreground'
      "
      :title="opt.label"
      @click="setMode(opt.value)"
    >
      <span aria-hidden="true">{{ opt.icon }}</span>
      <span class="sr-only">{{ opt.label }}</span>
    </button>
  </div>
</template>
